<template>
  <div
    class="shopItemDetail"
    :class="{noOption: options && options.length === 0, isOptionOpen: optionLayer}">
    <button type="button" class="btnBack notranslate" @click.stop="close">{{ locale.close }}</button>
    <div class="detailBox" :style="cartItemDetail && {opacity: 0}">
      <!-- 상품 이미지 -->
      <div class="shopInfo">
        <!-- 이용시간 -->
        <div
          v-if="!isHiddenAvailableTime && getAvailableTime && availableMessage"
          @click.stop="availableTable = true"
          :class="{disabled: !isAvailable}"
          class="availableTime notranslate">
          <span
            v-for="(time, index) in availableMessage"
            :key="index"
            class="timeItem">
            {{ time }}
          </span>
        </div>
        <!-- //이용시간 -->
        <!-- 상세이미지 -->
        <div class="images">
          <Carousel
            v-if="detailImage.length"
            ref="carousel"
            :loop="false"
            :perPage="1"
            :paginationSize="6"
            :paginationPadding="2"
            :paginationActiveColor="'rgba(30,30,30,0.7)'"
            :paginationColor="'rgba(200,200,200,0.7)'">
            <Slide
              v-for="(img, index) in detailImage"
              :key="index"
              :style="galleryStyle(img)"
              class="image">
            </Slide>
          </Carousel>
          <div v-else-if="thumb" class="image thumbImage">
            <img :src="thumb" alt="">
          </div>
          <div v-else class="image empty"></div>
        </div>
        <!-- //상세이미지 -->
      </div>
      <!-- //상품 이미지/설명 -->
      <!-- 상품 설명 -->
      <div class="shopOption">
        <div class="name">{{ displayShopItemName }}</div>
        <div v-if="descList.length > 0" :data-desc_multi="descList.length > 2" class="descList">
          <div v-for="(desc, index) in descList"
            :key="index"
            :style="descPotiion(desc)"
            :class="{isBottomItem: desc.isBottom}"
            class="descItem">
            <div v-if="desc.id && desc.name">
              <div v-if="desc.title && desc.title[lang]" :style="desc.style && descTitleFontSize(desc.style.fontSize)" class="descTitle">{{ desc.title && desc.title[lang] }}</div>
              <div v-if="desc.desc && desc.desc[lang]" :style="desc.style && descDescFontSize(desc.style.fontSize)" class="desc">{{ desc.desc && desc.desc[lang] }}</div>
            </div>
            <div v-else-if="desc[lang]" class="itemDesc">
              <div v-if="index !== 0" class="descTitle">{{ locale.desc }}</div>
              <div class="desc">{{ desc[lang] }}</div>
            </div>
          </div>
        </div>
        <!-- 모바일에서 기본노출, 태블릿에서 버튼을 통해 노출 -->
        <!-- 옵션 -->
        <div v-if="!(isStore && shopResponsive === 'tablet')"
          :id="separatedOption ? 'separatedOption' : ''" class="optionContainer"
          :class="{isOpen: optionLayer}">
          <div class="optionWrapper">
            <div v-if="options && options.length > 0" class="itemOptions" ref="itemOptions">
              <div class="descTitle notranslate">{{ locale.optional }}</div>
              <Options
                :locale="locale"
                :lang="lang"
                :shopItemId="shopItemId"
                :options="options"
                :cartOptions="cartItemDetail && cartItemDetail.options"
                class="optionBox" />
            </div>
            <div v-if="!isAuth" class="totalBox">
              <div class="btns notranslate">
                <button
                  type="button"
                  class="btn btnCart"
                  :style="getDefaultBtnStyle"
                  @click.stop="close">
                  {{ locale.confirm }}
                </button>
              </div>
            </div>
            <div v-else class="totalBox">
              <button type="button" class="btnCloseOption" @click="setOptionLayer(false, $event)"></button>
              <ItemQuantity
                v-if="detailItemInfo && !detailItemInfo.selectOptionByQuantity"
                :locale="locale"
                :lang="lang"
                :shopItemId="shopItemId"
                :detailItemInfo="detailItemInfo"
                class="notranslate" />
              <div class="totalPrice notranslate">
                {{ locale.total }}
                <span class="price">{{ priceFormat(detailPrice.total) }}</span>
              </div>
              <div>
                <div class="btns notranslate">
                  <button v-if="!isAuth"
                    type="button"
                    class="btn btnCart disabled"
                    @click.stop="close">
                    {{ locale.confirm }}
                  </button>
                  <button v-else-if="!isAvailable"
                    type="button"
                    class="btn btnCart disabled"
                    @click.stop="close">
                    {{ locale.not_available }}
                  </button>
                  <button v-else-if="status"
                    type="button"
                    class="btn btnCart disabled"
                    @click.stop="close">
                    {{ status[lang] }}
                  </button>
                  <button v-else-if="insufficient"
                    type="button"
                    class="btn btnCart disabled"
                    @click.stop="close">
                    {{ locale.insufficient_quantity }}
                  </button>
                  <button v-else-if="categoryItemLimit"
                    type="button"
                    class="btn btnCart disabled"
                    @click.stop="close">
                    {{ categoryItemLimit }}
                  </button>
                  <button v-else-if="timeIsExpired"
                    type="button"
                    class="btn btnCart disabled"
                    @click.stop="close">
                    {{ locale.over_order_time }}
                  </button>
                  <button v-else
                    type="button"
                    class="btn btnCart"
                    :class="{disabled: !isAuth || !isValid || !isAvailable || status}"
                    :style="getDefaultBtnStyle"
                    :disabled="!isAuth || !isValid || !isAvailable || status"
                    @click.stop="addCart">
                    {{ locale.add_cart }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- //옵션 -->
        <!-- //모바일에서 기본노출, 태블릿에서 버튼을 통해 노출 -->
        <div class="totalBox selectOptionBox">
          <div v-if="requiredItemQuantity.required > 1" class="remainMessage">
            {{ requiredQuantityMessage(detailItemInfo.selectQuantity.min === possibleMax, detailItemInfo.selectQuantity.min) }}
          </div>
          <div class="btns notranslate">
            <button v-if="detailItemInfo.hasOption || (options && options.length > 0)"
              type="button"
              class="btn btnCart notranslate"
              :style="getDefaultBtnStyle"
              @click.stop="setOptionDetail">
              {{ locale.select_option }}
            </button>
            <button v-else-if="!isAuth"
              type="button"
              class="btn btnCart notranslate"
              :style="getDefaultBtnStyle"
              @click.stop="close">
              {{ locale.confirm }}
            </button>
            <button v-else-if="!isAvailable"
              type="button"
              class="btn btnCart notranslate disabled"
              @click.stop="close">
              {{ locale.not_available }}
            </button>
            <button v-else-if="status"
              type="button"
              class="btn btnCart disabled"
              @click.stop="close">
              {{ status[lang] }}
            </button>
            <button v-else-if="insufficient"
              type="button"
              class="btn btnCart notranslate disabled"
              @click.stop="close">
              {{ locale.insufficient_quantity }}
            </button>
            <button v-else-if="categoryItemLimit"
              type="button"
              class="btn btnCart notranslate disabled"
              @click.stop="close">
              {{ categoryItemLimit }}
            </button>
            <button v-else-if="timeIsExpired"
              type="button"
              class="btn btnCart notranslate disabled"
              @click.stop="close">
              {{ locale.over_order_time }}
            </button>
            <button v-else
              type="button"
              class="btn btnCart notranslate"
              :style="getDefaultBtnStyle"
              :disabled="!isAuth || !isValid || !isAvailable"
              @click.stop="addCart">
              {{ locale.add_cart }}
            </button>
          </div>
        </div>
      </div>
      <!-- //상품 설명 -->
    </div>
    <AvailableTable
      v-if="getAvailableTime && availableTable"
      :locale="locale"
      :lang="lang"
      :table="getAvailableTime"
      @close="availableTable = false" />
    <DetailOptions
      v-if="(isStore && shopResponsive === 'tablet') && optionLayer"
      :locale="locale"
      :lang="lang"
      :shopResponsive="shopResponsive"
      :isAuth="isAuth"
      :isAvailable="isAvailable"
      :insufficient="insufficient"
      :categoryItemLimit="categoryItemLimit"
      :timeIsExpired="timeIsExpired"
      :status="status"
      :shopPageId="shopPageId"
      :shopItemId="shopItemId"
      :detailOption="detailOption"
      :cartOptions="cartItemDetail && cartItemDetail.options"
      :isValid="isValid"
      @applyOption="applyOption"
      @close="closeOptionDetail($event)" />
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import regExp from '@/common/regExp'
import moment from 'moment/moment'
import UNIQUE from '@/common/unique'
import DetailOptions from './DetailOptions'
import Options from './Options'
import ItemQuantity from './ItemQuantity'
import AvailableTable from '@/components/Util/AvailableTable'
import { timeState } from './timeTicker'
import { isAvailableNow } from '@/common/availableTimeChecker'

export default {
  name: 'shopDetail',
  props: [
    'locale',
    'lang',
    'responsive',
    'shopResponsive',
    'storeItemOption'
  ],
  components: {
    Carousel,
    Slide,
    DetailOptions,
    Options,
    ItemQuantity,
    AvailableTable
  },
  computed: {
    now () {
      return timeState.now
    },
    isAvailableComputed () {
      const now = this.now
      const availableTime = this.getAvailableTime
      return isAvailableNow(Array.isArray(availableTime) ? availableTime : [], now)
    },
    shopPageId () {
      return this.$route.params.shopPageId
    },
    shopCatcode () {
      return this.$store.getters['shop/getShopCatCode'](this.shopPageId)
    },
    getShopResultData () {
      return this.$store.getters['shop/getShopResultData']
    },
    siteCommon () {
      return this.$store.getters['common/getSetting']
    },
    shopItemId () {
      return this.$store.getters['shop/getDetailItemId']
    },
    isStore () {
      return this.$route.name === 'store'
    },
    itemPrice () {
      return this.priceInfo && this.priceInfo.gross
    },
    displayShopItemName () {
      const lang = this.lang
      const shopItemName = this.shopItemName[lang]
      const detailShopItemName = this.detailShopItemName[lang]
      return detailShopItemName || shopItemName
    },
    isHiddenAvailableTime () {
      const settings = this.$store.getters['shop/getShopSettings'](this.shopPageId)
      const isHidden = settings && settings.hiddenAvailableTime
      return isHidden
    },
    getAvailableTime () {
      const itemInfo = this.$store.getters['shop/getItemProperty'](this.shopItemId, this.shopCatcode)
      const presetId = itemInfo && itemInfo.availableTime
      return this.$store.getters['shop/getPresetProperty']('availableTime', (presetId || null))
    },
    availableMessage () {
      const timeTable = this.getAvailableTime
      if (!timeTable) return '00:00-24:00'
      const today = moment().isoWeekday() - 1
      const day = timeTable[today]
      return day && day.available ? day.time.map((x) => `${x.from}-${x.to}`) : ['00:00-24:00']
    },
    total () {
      const itemPrice = this.itemPrice
      return itemPrice
    },
    // 상품정보
    detailItemInfo () {
      const info = this.$store.getters['shop/getDetailItemInfo']
      /**
       * quantity 보정
       * quantity < min 불가
       * quantity > (possibleMax || max) 불가
       * min > possibleMax 인 경우, quantity = possibleMax
       */
      function normalizeQuantity (input, selectOptionByQuantity, possibleMax) {
        const data = { ...input } // 원본 보존
        const sq = data.selectQuantity || {}

        const toNum = v => (v === null || v === undefined ? undefined : Number(v))
        const isFiniteNum = v => Number.isFinite(v)

        const min = toNum(selectOptionByQuantity ? 1 : sq.min)
        const max = toNum(sq.max)

        // 상한 결정: possibleMax 우선, 없으면 max, 둘 다 없으면 Infinity
        const upper = isFiniteNum(possibleMax)
          ? possibleMax
          : (isFiniteNum(max) ? max : Infinity)

        // 특수 규칙(4): min > possibleMax 이면 quantity = possibleMax
        if (isFiniteNum(min) && isFiniteNum(possibleMax) && min > possibleMax) {
          data.quantity = Math.floor(possibleMax)
          return data
        }

        // 기본 클램프
        let q = toNum(data.quantity);
        if (!isFiniteNum(q)) q = 1 // 비정상 값 대비 기본값
        q = Math.floor(q) // 정수화

        if (isFiniteNum(min) && q < min) q = Math.floor(min)
        if (q > upper) q = Math.floor(upper)

        data.quantity = q
        return data
      }
      return info && {
        shopItemId: this.shopItemId,
        shopItemName: this.detailShopItemName || this.shopItemName,
        selectOptionByQuantity: info.selectOptionByQuantity,
        categoryId: info.categoryId,
        hasOption: info.hasOption,
        ...normalizeQuantity({
          quantity: info.quantity,
          selectQuantity: info.selectQuantity,
        }, info.selectOptionByQuantity, this.possibleMax),
        ...this.thumb && {
          thumb: this.thumb
        },
        ...info.price && {
          priceInfo: {
            gross: info.price
          }
        },
        ...info.pId && {
          pId: info.pId
        },
        ...info.isCallItem && {
          isCallItem: info.isCallItem
        },
        ...info.availableTime && {
          availableTime: info.availableTime
        },
        ...info.status && {
          status: info.status
        },
        ...info.passFirstOption && {
          passFirstOption: info.passFirstOption
        }
      }
    },
    // 상품옵션정보
    detailOption () {
      return this.$store.getters['shop/getDetailOptions']
    },
    // cart, submit을 위한 데이터매핑
    detailData () {
      const option = this.detailOption
      const optionList = option && Object.keys(option)
      const detailOption = optionList && optionList.length > 0
        ? optionList.map(x => {
          const optionItems = option[x].optionItems.map(o => {
            return {
              ...o.value !== undefined && {
                value: o.value
              },
              ...o.optionItemId && {
                optionItemId: o.optionItemId
              },
              ...o.name && {
                name: o.name
              },
              ...o.quantity && {
                quantity: o.quantity
              },
              ...o.shopItemId && {
                shopItemId: o.shopItemId
              },
              ...o.price && {
                priceInfo: {
                  gross: o.price
                }
              },
              ...o.pId && {
                pId: o.pId
              }
            }
          })
          return {
            ...option[x].id && {
              id: option[x].id
            },
            ...option[x].optionId && {
              optionId: option[x].optionId
            },
            name: option[x].name,
            optionItems: optionItems,
            ...getSubOption(x)
          }
        })
        : null
      const options = detailOption && detailOption.filter(x => x.optionItems.length > 0)
      function getSubOption (key) {
        const parts = key.split('_unique_')
        if (parts.length === 4) {
          const [shopItemId, optionId, optionItemId, slefId] = parts
          return {
            parentOption: optionId,
            parentOptionItem: optionItemId
          }
        }
        return null
      }
      // 상위옵션-서브옵션 순서로 정렬
      function sortWithParentChildren (options) {
        const childrenMap = new Map()
        const insertedChildren = new Set()
        const result = []

        // 부모 optionId별로 하위 옵션 그룹 수집
        options.forEach(option => {
          if (!option.parentOption) return

          const children = childrenMap.get(option.parentOption) || []
          children.push(option)
          childrenMap.set(option.parentOption, children)
        })

        // 최상위 옵션만 순회
        options.forEach(option => {
          if (option.parentOption) return

          result.push(option)

          const parentId = option.id || option.optionId
          const children = childrenMap.get(parentId) || []

          children.forEach(child => {
            result.push(child)
            insertedChildren.add(child)
          })
        })

        // 부모 매칭에 실패한 하위 옵션이 있다면 원본 순서대로 뒤에 보존
        options.forEach(option => {
          if (option.parentOption && !insertedChildren.has(option)) {
            result.push(option)
          }
        })

        return result
      }
      return {
        ...this.detailItemInfo,
        ...options && options.length > 0 && {
          options: sortWithParentChildren(options)
        }
      }
    },
    getDetailIsValid () {
      return this.$store.getters['shop/getDetailValid']
    },
    detailPrice () {
      const details = this.detailData
      const itemPrice = Number(details && details.priceInfo && details.priceInfo.gross) || 0 //상품자체 단가
      const itemQuantity = details && details.quantity
      const options = details && details.options && details.options.flatMap(x => x.optionItems)
      const optionTotal = options ? options.reduce((sum, item) => sum + Number((item && item.priceInfo && item.priceInfo.gross) || 0) * item.quantity, 0) : 0
      return {
        itemPrice: itemPrice,
        itemQuantity: itemQuantity,
        optionPrice: optionTotal,
        total: (itemPrice + optionTotal) * itemQuantity
      }
    },
    separatedOption () {
      const options = this.options && this.options.length > 0
      return options
    },
    isAuth () {
      const isAuth = this.$store.getters['authentication/isAuth']
      return isAuth
    },
    // 최저수량보다 주문가능한 최대수량이 작을때
    insufficient () {
      const selectQuantity = this.detailItemInfo && this.detailItemInfo.selectQuantity
      return !this.cartItemDetail && selectQuantity && (this.possibleMax < selectQuantity.min)
    },
    // 이 아이템이 속한 카테고리에 개수제한이 있는지?
    categoryItemLimit () {
      const catCode = this.$store.getters['shop/getShopCatCode'](this.shopPageId)
      const categoryId = this.detailItemInfo && this.detailItemInfo.categoryId
      const limitCount = categoryId && this.$store.getters['shop/getCategoryLimitCount'](this.shopPageId, catCode, categoryId)
      const categoryLabel = this.$store.getters['shop/getCategoryNode'](this.shopPageId, categoryId)
      const isLimit = limitCount && limitCount.possibleMax === 0
      return !this.cartItemDetail && categoryLabel && isLimit && `${categoryLabel.categoryLabel[this.lang]} ${this.locale.nolonger_add_items}`
    },
    // 주문가능시간이 만료되었을 때
    timeIsExpired () {
      return this.$store.getters['shop/getShopOrderTimeout'](this.shopPageId)
    },
    isValid () {
      const options = this.detailOption
      function hasInvalidData (data) {
        if (!data) return true // data가 null 또는 undefined이면 true 반환
        return Object.values(data).some(entry => !entry.isValid)
      }
      return !hasInvalidData(options)
    },
    getDefaultBtnStyle () {
      return this.$store.getters['common/getDefaultBtnStyle']
    },
    cartItemDetail () {
      const detail = this.$store.getters['shop/getDetailItemInfo']
      const cartItemId = detail && detail.cartItemId
      const cartItemInfo = cartItemId && this.$store.getters['cart/getCartItem'](cartItemId)
      return cartItemInfo && {
        cartId: cartItemInfo.cartId,
        options: cartItemInfo.payload.options
      }
    },
    // 현재 장바구니에 담긴 동일 상품리스트
    requiredItemQuantity () {
      const shopItemId = this.shopItemId
      const getCartShopItems = this.$store.getters['cart/getCartShopItems'](shopItemId, this.isStore)
      const getItemProperty = this.$store.getters['shop/getItemProperty'](shopItemId, this.isStore)
      const itemProperty = getItemProperty ? {
        shopItemId: shopItemId, // shopItemId
        limit: Number(this.possibleMax), // 주문가능한 최대개수
        required: Number(getItemProperty.quantity.min), // 주문가능한 최대개수
        quantity: this.detailData.quantity
      } : null
      return getCartShopItems || itemProperty
    },
    // 실제 선택 가능한 수량 최대치
    possibleMax () {
      const shopPageId = this.shopPageId
      const shopCatCode = this.$store.getters['shop/getShopCatCode'](shopPageId)
      const shopItemId = this.shopItemId
      return this.$store.getters['shop/getItemPossibleMax'](shopCatCode, shopItemId, this.isStore)
    },
  },
  watch: {
    storeItemOption (isOpen) {
      if (!isOpen) {
        this.optionLayer = false
      }
    },
    isAvailableComputed: {
      immediate: true,
      handler (val) {
        this.isAvailable = val
      }
    }
  },
  async created () {
    const shopItemId = this.shopItemId
    window.addEventListener('scroll', this.handleScroll)
    if (shopItemId) {
      const info = this.$store.getters['shop/getItemProperty'](shopItemId, this.isStore)
      this.shopItemName = info.shopItemName || {}
      this.detailShopItemName = info.detailShopItemName && info.detailShopItemName.active
        ? info.detailShopItemName.shopItemName
        : info.shopItemName
      this.detailImage = info.detailImage || []
      this.desc = info.desc || {}
      this.priceInfo = info.priceInfo || {}
      this.thumb = info.thumb
      this.selectOptionByQuantity = info.selectOptionByQuantity || false
      this.directOption = (info.option && info.option.length > 0 && info.directOption) || false

      // 옵션의 원본 데이터 대신 preset, store option 모두 조회한 옵션배열
      this.options = (info.optionProperty && await this.getOptionDetail(info.optionProperty)) || []

      // 옵션 선택사항 store 저장 방식
      if (this.options.length > 0) {
        this.$store.commit('shop/setDetailOptions',
          this.options.map(x => {
            const isCheckbox = x.type === 'checkbox'
            const isSelect = x.type === 'select'
            return {
              ...x.id && { // 스토어의 option.id + 프리셋의 optionIds[].id
                id: x.id
              },
              ...x.optionId && { // 상품에서 직접등록한 option
                optionId: x.optionId
              },
              name: x.name,
              uniqueId: x.uniqueId,
              isValid: !x.isRequired,
              optionItems: x.optionItems.filter((o, i) => {
                return !o.status && (o.isDefault || (isSelect && x.isRequired && i === 0))
              }).map(o => {
                return {
                  id: o.id,
                  quantity: o.quantity,
                  optionItemId: o.optionItemId,
                  ...o.price && {
                    price: o.price,
                    totalPrice: o.price
                  },
                  ...o.pId && {
                    pId: o.pId
                  },
                  ...o.status && {
                    status: o.status
                  }
                }
              })
            }
          })
        )
      }
      if (this.cartItemDetail) {
        this.setOptionDetail()
      }
      if (this.directOption) {
        this.setOptionDetail()
      }

      if (info.status) {
        const presetId = info.status
        const status = presetId && this.$store.getters['shop/getPresetProperty']('status', presetId)
        this.status = status && status.text
      }
      if (info.descList && info.descList.length > 0) {
        let addDesc = []

        info.descList.forEach(item => {
          if (item) {
            if (item.desc && item.desc[this.lang]) {
              addDesc.push({ ...item.desc })
            } else if (typeof item === 'string') {
              const descPreset = this.$store.getters['shop/getPresetProperty']('details', item)
              if (descPreset) {
                addDesc.push({ ...descPreset })
              }
            }
          }
        })

        addDesc.sort((a, b) => {
          const aBottom = a.descPositionBottom ? 1 : 0
          const bBottom = b.descPositionBottom ? 1 : 0
          return aBottom - bBottom
        })

        const firstBottomIndex = addDesc.findIndex(i => i.descPositionBottom)

        this.descList = addDesc.map((item, index) => {
          return {
            ...item,
            isBottom: index === firstBottomIndex
          }
        })
      }
      this.isReady = true
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  data () {
    return {
      isReady: false,
      shopItemName: {},
      detailShopItemName: {},
      detailImage: [],
      desc: {},
      descList: [],
      options: null,
      priceInfo: {},
      thumb: '',
      availableTable: false,
      status: null,
      checkAvailable: 0,
      isAvailable: true,
      optionLayer: false,
      directOption: false,
      selectOptionByQuantity: false
    }
  },
  methods: {
    async getItemProperty () {
      const shopItemId = this.shopItemId
      const getItemProperty = await this.$store.dispatch('shop/getShopItems', [shopItemId])
      const itemProperty = getItemProperty && getItemProperty.message && getItemProperty.message.shopItems && getItemProperty.message.shopItems[shopItemId]
      if (itemProperty) {
        this.$store.dispatch('shop/upsertItemProperty', { [shopItemId]: itemProperty })
        this.$emit('update', shopItemId)
      }
      return shopItemId
    },
    // 최소 수량만큼 1개씩 옵션을 선택해야 하는 경우 최소 수량을 만족할 때까지 주문해야함
    orderAgain () {
      if (this.$refs.itemOptions) {
        this.$refs.itemOptions.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
      if (this.isStore && this.shopResponsive === 'tablet') {
        if (this.options && this.options.length > 0) {
          this.setOptionDetail()
        }
      }
    },
    requiredQuantityMessage (isEqual, quantity) { // min === max ?
      const message = isEqual ? this.locale.shop_required_equal_quantity : this.locale.shop_required_min_quantity
      return message.replace('{var}', quantity)
    },
    handleScroll (e) {
      e.stopPropagation()
    },
    descPotiion (desc) {
      const positionBottom = desc && desc.isBottom
      return positionBottom && {
        marginTop: 'auto'
      }
    },
    // 상세설명 폰트사이즈
    descTitleFontSize (fontSize) {
      const defaultTitleSize = 1 // desc default font size
      const titleFontSize = fontSize && fontSize.title && (defaultTitleSize + (parseInt(fontSize.title) - 3) * 0.1)
      return {
        fontSize: titleFontSize ? `${titleFontSize}em` : `${defaultTitleSize}em`
      }
    },
    descDescFontSize (fontSize) {
      const defaultDescSize = 0.8 // desc default font size
      const descFontSize = fontSize && fontSize.desc && (defaultDescSize + (parseInt(fontSize.desc) - 3) * 0.1)
      return {
        fontSize: descFontSize ? `${descFontSize}em` : `${defaultDescSize}em`
      }
    },
    async getOptionDetail (options) {
      const getOptionListData = this.$store.getters['shop/getOptionListData'](this.shopPageId, this.shopItemId, options)
      this.$store.commit('shop/setDetailOptionArray', getOptionListData)
      return getOptionListData
    },
    galleryStyle (src) {
      return {
        background: `url('${src}') 50% 50% / cover no-repeat`
      }
    },
    priceFormat (price) {
      const currency = this.$store.getters['shop/getShopCurrency'] || null
      return this.$store.getters['util/getPriceFormatter'](price, currency)
    },
    applyOption () {
      this.addCart()
    },
    setOptionLayer (isOpen, e) {
      if (!isOpen) this.$store.commit('shop/setDetailItem', null)
      
      if (this.separatedOption) {
        if (e) e.preventDefault()
        this.optionLayer = isOpen
      }
    },
    setOptionDetail ($event) {
      // if (!this.isReady) return

      this.setOptionLayer(true, $event)
      if (this.isStore) {
        this.$emit('setDetailOption', this.shopItemId)
      }
    },
    closeOptionDetail ($event) {
      this.setOptionLayer(false, $event)
      this.$emit('setDetailOption')
      this.close()
    },
    close ($event) {
      this.setOptionLayer(false, $event)
      this.$store.commit('shop/setDetailItem', null)
    },
    async addCart () {
      const shopPageId = this.shopPageId
      const shopCatCode = this.$store.getters['shop/getShopCatCode'](shopPageId)
      const payload = {
        ...this.detailData,
        totalPrice: (this.detailPrice && this.detailPrice.total) || 0,
        createat: new Date().toISOString(),
        updateat: new Date().toISOString()
      }
      const data = {
        payload: payload,
        shopPageId: shopPageId,
        shopItemId: payload.shopItemId,
        catCode: shopCatCode,
        ...this.cartItemDetail && {
          cartId: this.cartItemDetail.cartId
        }
      }
      if (!this.cartItemDetail && this.detailData.selectQuantity && this.possibleMax === 0) return
      this.$emit('addCart', data)
    }
  }
}
</script>
